import { Alert, Button, Column, Divider, Loader, Row, Text, Toggle } from "@amzn/meridian";
import React from "react";
import {
  setShowHighlight,
  setShowTranslation,
  translate,
} from "src/store/modelLifeCycleGroundTruthSlice";
import { useAppDispatch, useAppSelector } from "src/store/store";

const ReviewText = () => {
  const dispatch = useAppDispatch();

  const {
    selectedGroundTruthData,
    showHighlight,
    showTranslation,
    translation,
    translationLoading,
    textHighlightLoading,
  } = useAppSelector((state) => state.modelLifeCycleGroundTruthSlice);

  return (
    <Column alignmentVertical="justify">
      <Row overflowY="auto" height={"69vh"} alignmentVertical="top" spacingInset={"400"}>
        <Text
          id="incident-description-container"
          fontFamily="amazonEmber"
          type="b500"
          color="primary"
        >
          <div className="text-content">
            {showTranslation && (
              <Column spacingInset={"500 0 0 0"}>
                <Alert size={"medium"} type="warning">
                  Please use translation only for reference, Excavator will extraction base on
                  original text content
                </Alert>
              </Column>
            )}
            {showTranslation ? (
              <p id="incident-description" className="paragraph-style">
                {translation}
              </p>
            ) : (
              <p id="incident-description" className="paragraph-style">
                {selectedGroundTruthData.sourceText}
              </p>
            )}
          </div>
        </Text>
      </Row>
      <Divider spacingAfter={"0"} />
      <Row alignmentHorizontal="justify" alignmentVertical="center" spacingInset={"0 400 400 400"}>
        {translationLoading === "pending" ? (
          <Loader size={"small"}></Loader>
        ) : showTranslation ? (
          <Button
            size={"small"}
            onClick={() => dispatch(setShowTranslation(false))}
            type={"secondary"}
          >
            See original source text
          </Button>
        ) : (
          <Button
            onClick={() =>
              dispatch(
                translate({
                  text: selectedGroundTruthData.sourceText,
                }),
              )
            }
          >
            Translate to English
          </Button>
        )}
        <Row>
          <Text>Show highlight:</Text>
          {textHighlightLoading === "pending" && <Loader size={"small"}></Loader>}
          <Toggle
            checked={showHighlight}
            onChange={() => dispatch(setShowHighlight(!showHighlight))}
          ></Toggle>
        </Row>
      </Row>
    </Column>
  );
};

export default ReviewText;
